import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';

import { MinMaxNumberValues } from '../../../../apis/graphql/types';
import useScrollHandler from '../../../../hooks/useScrollHandler/useScrollHandler';
import { globalCloseEvents, tooltipStyles } from '../constants';
import FilterContent from './FilterContent';
import { StyledFilterIcon, StyledFilterWrapper } from './styled';

type Props = {
  elementId: string;
  choosenData?: MinMaxNumberValues;
  onChange: (obj: MinMaxNumberValues) => void;
  showCurrency?: boolean;
};

const MinMaxFilter = ({ elementId, choosenData, onChange, showCurrency }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  useScrollHandler(() => setIsOpen(false));

  const handleOpenFilter = (e: React.MouseEvent<SVGSVGElement, MouseEvent>): void => {
    setIsOpen((state) => !state);
  };

  const handleCloseFilter = (): void => {
    setIsOpen(false);
  };

  const handleApplyFilter = (filterValue: MinMaxNumberValues): void => {
    onChange(filterValue);
    setIsOpen(false);
  };

  return (
    <StyledFilterWrapper>
      <StyledFilterIcon
        data-tooltip-id={elementId}
        data-testid={elementId}
        $active={isOpen || Boolean(choosenData?.min) || Boolean(choosenData?.max)}
        onClick={handleOpenFilter}
      />
      {createPortal(
        <Tooltip
          id={elementId}
          place="bottom"
          style={tooltipStyles}
          openOnClick={true}
          clickable={true}
          isOpen={isOpen}
          delayHide={0}
          setIsOpen={(): void => {
            if (isOpen) {
              setIsOpen(false);
            }
          }}
          opacity={1}
          globalCloseEvents={globalCloseEvents}
          noArrow={true}
          variant="light"
          className="descriptionTooltip"
        >
          <div data-testid="filterContent">
            <FilterContent
              choosenData={choosenData}
              showCurrency={showCurrency}
              handleCloseFilter={handleCloseFilter}
              handleApplyFilter={handleApplyFilter}
            />
          </div>
        </Tooltip>,
        document.body
      )}
    </StyledFilterWrapper>
  );
};

export default MinMaxFilter;
